import { Users, Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useLang } from '../contexts/LanguageContext';
import { useData } from '../contexts/DataContext';

export default function Vehicles() {
  const { vehicles, loading } = useData();
  const { t, lang } = useLang();

  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  if (loading) {
    return (
      <section className="py-24 bg-[#112240]">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="animate-pulse text-slate-400">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="vehicles" className="py-24 bg-[#112240]" data-testid="vehicles-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-cyan-400 text-sm uppercase tracking-[0.2em] mb-4 font-semibold">{t('veh_label')}</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight mb-6">
            {t('veh_title_1')} <span className="gradient-text">{t('veh_title_2')}</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">{t('veh_desc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {vehicles.map((vehicle, index) => (
            <div key={vehicle.id} className="premium-card card-hover group overflow-hidden flex flex-col lg:flex-row" data-testid={`vehicle-card-${index}`}>
              <div className="lg:w-1/2 h-64 lg:h-auto relative overflow-hidden">
                <img src={vehicle.image_url} alt={vehicle.name} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#112240] lg:block hidden" />
              </div>
              <div className="lg:w-1/2 p-6 lg:p-8 flex flex-col justify-center">
                <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors">{vehicle.name}</h3>
                <div className="flex items-center gap-2 mb-4">
                  <div className="bg-cyan-500/20 text-cyan-400 px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-1">
                    <Users className="w-4 h-4" />
                    {vehicle.capacity_min}-{vehicle.capacity_max} {t('passengers').toLowerCase()}
                  </div>
                </div>
                <p className="text-slate-400 mb-6">
                  {lang === 'es' ? (vehicle.description_es || vehicle.description) : vehicle.description}
                </p>
                <div className="space-y-2 mb-6">
                  <div className="flex items-center gap-2 text-slate-300 text-sm">
                    <Check className="w-4 h-4 text-green-400" /><span>{t('veh_ac')}</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300 text-sm">
                    <Check className="w-4 h-4 text-green-400" /><span>{t('veh_driver')}</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-300 text-sm">
                    <Check className="w-4 h-4 text-green-400" /><span>{t('veh_luggage')}</span>
                  </div>
                </div>
                <Button className="bg-gradient-to-r from-orange-600 to-yellow-500 text-black font-bold uppercase tracking-wide hover:brightness-110 transition-all btn-glow"
                  onClick={scrollToBooking} data-testid={`vehicle-reserve-${index}`}>
                  {t('veh_reserve')}
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
